export default "__VITE_ASSET__RU7Qm6mY__"